var getCurrentProject = function(state) {
    return state.project.currentProject;
};
var projectSelectors = {
    getCurrentProject: getCurrentProject
};
export default projectSelectors;
